import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {AnalyticsCommonDataItem, AnalyticsData} from "../../services/analytics-dashboard.service";

@Component({
    selector: 'app-dashboard-common-stats',
    templateUrl: './dashboard-common-stats.component.html',
    styleUrls: ['./dashboard-common-stats.component.scss']
})
export class DashboardCommonStatsComponent implements OnInit, OnChanges {

    @Input()
    data: AnalyticsCommonDataItem;

    _data: AnalyticsCommonDataItem = null;

    @Input()
    metric: string;

    categories: { [key: string]: Array<{ id: string, name: string }> };
    products: { [key: string]: Array<{ id: string, name: string }> };

    selectedProduct = null;
    selectedCategory = null;

    constructor() {
    }

    ngOnInit() {
    }


    ngOnChanges(changes: SimpleChanges): void {
        if(changes.data.currentValue){
            // categories
            let categories = changes.data.currentValue.map((c) => {
                let parts = c.category ?c.category.split(':') : [];
                if(parts.length > 1){
                    c.category = parts[1];
                    c.product = parts[0]
                }
                return c;
            });
            this.categories = categories
                .filter((value, index, self) => {
                    return self.find((item) => item.category === value.category) === value;
                })
                .map((item) => ({id: item.category, name: item.category}));

            this.products = categories
                .filter((value, index, self) => {
                    return self.find((item) => item.product === value.product) === value;
                })
                .map((item) => ({id: item.product, name: item.product}));


            if(this._data === null) {
                this._data = JSON.parse(JSON.stringify(changes.data.currentValue)); // clone original data
            }
        }
    }

    subcategoryChanged(event) {
        if(!event){
            this.selectedCategory = null;
        }else{
            this.selectedCategory = event.id;
        }
        this.data = this._data.filter((item) => !this.selectedCategory || item.category === this.selectedCategory && !this.selectedProduct || (item.category === this.selectedCategory && (this.selectedProduct && this.selectedProduct === item.product)));

    }

    productChanged(event) {
        if(!event){
            this.selectedProduct = null;
        }else {
            this.selectedProduct = event.id;
        }
        this.data = this._data.filter((item) => !this.selectedProduct || item.product === this.selectedProduct && !this.selectedCategory || (item.product === this.selectedProduct && (this.selectedCategory && this.selectedCategory === item.category)));

    }
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard-common-stats/dashboard-common-stats.component.ts